import React from 'react';
import { Row, Col } from 'bootstrap';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import StartTimeMixin from 'main/components/show/cuesheet/startTimeMixin';
import CuesheetResponsiveActions from 'flux/actions/cuesheet/CuesheetResponsiveActions';
import Duration from 'main/components/show/cuesheet.responsive/itemDuration.jsx';
import StartTime from 'main/components/show/cuesheet.responsive/itemStartTime.jsx';
import PresetDuration from 'main/components/show/cuesheet.responsive/itemPresetDuration.jsx';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import HighlightCellMixin from 'main/components/show/cuesheet/highlightCellMixin';
import ItemNumber from 'main/components/show/cuesheet.responsive/itemNumber.jsx';
import ItemTitle from 'main/components/show/cuesheet.responsive/itemTitle.jsx';
import ItemCog from 'main/components/show/cuesheet.responsive/itemCog.jsx';
import ItemLock from 'main/components/show/cuesheet.responsive/itemLock.jsx';
import CueListItemMixin from 'main/components/show/cuesheet.responsive/cueListItemMixin.jsx';
import CueListItemTrackingMixin from 'main/components/show/cuesheet.responsive/cueListItemTrackingMixin.jsx';
import classNames from 'classnames';

export default React.createClass({
  mixins: [
    StartTimeMixin,
    PureRenderMixin,
    HighlightCellMixin,
    CueListItemMixin,
    CueListItemTrackingMixin,
  ],

  getInitialState() {
    return { loading: true };
  },

  render() {
    const {
      displayDuration,
      displayStartTime,
      displayPresetDuration,
      isCopied,
      isTracked,
      isTitle,
    } = this.props;

    const className = classNames('csr-list-item', {
      'csr-list-item-copied': isCopied,
      'csr-list-item-tracked': isTracked,
      'csr-list-item-title': isTitle,
    });

    return (
      <div
        style={Object.assign(
          {},
          this.getGlobalHighlightStyle(),
          this.getPersonalHighlightStyle(),
        )}
        className={className}
        ref={(e) => {
          if (e) this.refs.item = e;
        }}
      >
        <Row>
          <Col className="csr-item-settings" lg={3} md={4} sm={5} xs={6}>
            {this._getItemLockNode()}
            {this._getItemNumberNode()}
            {this._getItemCogNode()}
          </Col>
          <Col lg={17} md={17} sm={19} xs={18}>
            <div className="csr-item-wrapper">
              {this._getItemTitleNode()}
              <div className="csr-item-start-time">
                {displayStartTime ? this._getItemStartTimeNode() : null}
              </div>
              <div className="csr-item-preset-dur">
                {displayPresetDuration
                  ? this._getItemPresetDurationNode()
                  : null}
              </div>
              <div className="csr-item-dur">
                {displayDuration ? this._getItemDurationNode() : null}
              </div>
            </div>
          </Col>

          <Col lg={3} md={3} sm={1} xs={1} className="pull-right">
            <div className="csr-item-detail-link text-center">
              <Icon
                name="angle-right"
                size={3}
                onClick={() => {
                  CuesheetResponsiveActions.showCueDetail();
                  this._setItemDetailFocus();
                }}
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  },

  _getItemCogNode() {
    return <ItemCog rowIndex={this.props.rowIndex} />;
  },

  _getItemLockNode() {
    return <ItemLock isLocked={this.props.item.get('locked')} />;
  },

  _getItemStartTimeNode() {
    return (
      <StartTime
        rowIndex={this.props.rowIndex}
        twentyFourHourClock={this.props.twentyFourHourClock}
        item={this.props.item}
      />
    );
  },

  _getItemPresetDurationNode() {
    const { presetDurationDisplayType, rowIndex, item } = this.props;

    return (
      <PresetDuration {...{ presetDurationDisplayType, rowIndex, item }} />
    );
  },

  _getItemDurationNode() {
    const { durationDisplayType, rowIndex, item } = this.props;

    return <Duration {...{ durationDisplayType, rowIndex, item }} />;
  },

  _getItemNumberNode() {
    const { item, rowIndex } = this.props;

    return (
      <ItemNumber itemNumber={item.get('numberAdjusted')} rowIndex={rowIndex} />
    );
  },

  _getItemTitleNode() {
    const { item, rowIndex } = this.props;

    return <ItemTitle item={item} rowIndex={rowIndex} />;
  },
});
